import { render, staticRenderFns } from "./mealEdit.vue?vue&type=template&id=58f4ed84&"
import script from "./mealEdit.vue?vue&type=script&lang=js&"
export * from "./mealEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports